import type { Request, Response } from 'express';
import type { LocationState } from 'history';

import type createAppStore from 'promotions/store';

export type AppStore = ReturnType<typeof createAppStore>;

export type universalRouterProps = {
  store: AppStore;
  isServer?: boolean;
  res?: Response;
  req?: Request;
};

export class Location {
  readonly pathname: string = '/';
  readonly key?: string = '';
  readonly search?: string = '';
  readonly hash?: string = '';
  readonly state?: LocationState | null = {};
  readonly protocol?: string = '';
  constructor(init?: Partial<Location>) {
    Object.assign(this, init);
  }
}
